import { z } from "zod";
import { ULID_BODY } from "../ulid.js";
/**
 * Namespaced ULID factory. Pass the expected prefix, e.g. `ULIDSchema("hh")` produces a
 * schema that accepts `hh_01H8XYZA0BC1D2E3F4G5H6J7K8` and rejects any other prefix.
 */
export function ULIDSchema(prefix) {
    return z
        .string()
        .refine((value) => {
        const match = /^([a-z]{2,8})_(.+)$/.exec(value);
        if (!match)
            return false;
        return match[1] === prefix && ULID_BODY.test(match[2]);
    }, { message: `must be a namespaced ULID with prefix '${prefix}_'` });
}
/** UTC ISO 8601 timestamp with Z suffix. */
export const ISODateSchema = z.string().refine((value) => {
    if (!value.endsWith("Z"))
        return false;
    const date = new Date(value);
    return (!Number.isNaN(date.getTime()) &&
        date.toISOString().replace(/\.\d+Z$/, "Z") === value.replace(/\.\d+Z$/, "Z"));
}, { message: "must be UTC ISO 8601 with Z suffix" });
//# sourceMappingURL=primitives.js.map